module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_48-23b40ae3d262d5ff8311685b667da8e8.png";